function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgAssignment = function SvgAssignment(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Assignment' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M24 47C11.3 47 1 36.7 1 24S11.3 1 24 1s23 10.3 23 23-10.3 23-23 23zm0-1.84c11.7 0 21.16-9.47 21.16-21.16C45.16 12.3 35.7 2.84 24 2.84 12.3 2.84 2.84 12.3 2.84 24c0 11.7 9.47 21.16 21.16 21.16z"
  }), React.createElement("path", {
    d: "M36 19h-8v-8H18v4h-2V9h14.4l7.6 7.6V37h-6v-2h4V19zm-.4-2L30 11.4V17h5.6z"
  }), React.createElement("path", {
    d: "M21 30c-2.16 0-3.6-1.17-4.35-3.13-.5-1.3-.65-2.74-.65-4.6 0-2.9 2.22-5.27 5-5.27s5 2.37 5 5.26c0 1.87-.16 3.3-.65 4.6C24.6 28.84 23.15 30 21 30zm0-2c2.24 0 3-2 3-5.74 0-1.8-1.36-3.26-3-3.26s-3 1.45-3 3.26C18 26 18.76 28 21 28z"
  }), React.createElement("path", {
    d: "M14 37h14v-2.03c0-.32-.4-.74-1.53-1.16-1.36-.5-3.33-.8-5.47-.8-2.12 0-4.1.3-5.47.83-1.12.43-1.53.85-1.53 1.14V37zm-2-2.03c0-2.73 4.5-3.97 9-3.97s9 1.18 9 3.97V39H12v-4.03z"
  }));
};

SvgAssignment = pure(SvgAssignment);
SvgAssignment.displayName = 'SvgAssignment';
export default SvgAssignment;